import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Camera, Info } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { ReportCard } from '../../components/manutenzione/ReportCard';
// Mock data
const mockReport = {
  id: '1',
  type: 'Oggetto Rotto',
  emoji: '🔧',
  isBlocking: true,
  reportedBy: {
    name: 'Mario R.',
    role: 'Fornitore pulizie'
  },
  timestamp: 'Oggi 10:32',
  area: 'Bagno principale',
  severity: 4,
  description: 'Il rubinetto del lavandino perde acqua continuamente. La perdita sembra provenire dalla base del rubinetto. Ho provato a stringere ma continua a perdere.',
  photos: ['https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&w=600&q=80', 'https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&w=600&q=80', 'https://images.unsplash.com/photo-1604709177225-055f99402ea3?auto=format&fit=crop&w=600&q=80']
};
export function ReportsDetailPage() {
  const navigate = useNavigate();
  // Sempre espansa - no toggle
  const [isExpanded] = useState(true);
  const handleTakeBeforePhotos = () => {
    navigate('/manutenzione/before-photos/property-123');
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-1510">
      <main className="flex-1 max-w-4xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-8 pb-32" data-id="element-1511">
        {/* Page Header */}
        <div className="mb-12" data-id="element-1512">
          <h1 className="text-4xl font-bold text-navy mb-3" data-id="element-1513">
            Via Roma 123, Appartamento 4B
          </h1>
          <div className="flex items-center gap-2" data-id="element-1514">
            <span className="px-4 py-2 bg-red-50 text-red-700 rounded-full text-base font-semibold border border-red-200" data-id="element-1515">
              1 segnalazione attiva
            </span>
          </div>
        </div>

        {/* Report Card - Always Expanded */}
        <div className="mb-12" data-id="element-1516">
          <ReportCard report={mockReport} isExpanded={isExpanded} onToggle={() => {}} // No-op perché è sempre espansa
        forceExpanded={true} data-id="element-1517" />
        </div>

        {/* Info Note */}
        <div className="bg-blue-50 border border-blue-100 rounded-xl p-6 mb-12" data-id="element-1518">
          <div className="flex items-start gap-3" data-id="element-1519">
            <Info className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-1520" />
            <div data-id="element-1521">
              <p className="text-base text-blue-900 font-semibold mb-2" data-id="element-1522">
                Prima di iniziare l'intervento
              </p>
              <p className="text-base text-blue-900 leading-relaxed" data-id="element-1523">
                Scatta delle foto dello stato attuale del problema. Questo
                aiuterà a documentare l'intervento e a confrontare il prima e il
                dopo.
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* Fixed Bottom CTA */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 md:p-6 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] z-40" data-id="element-1524">
        <div className="max-w-4xl mx-auto" data-id="element-1525">
          <Button onClick={handleTakeBeforePhotos} className="w-full text-lg h-14" data-id="element-1526">
            <Camera className="w-6 h-6" data-id="element-1527" />
            Scatta Foto del Prima
          </Button>
        </div>
      </div>
    </div>;
}